export default function StateListModal({ states, onClose }:
    {
        states: string[], onClose: () => void;
    }
) {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
            <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative">
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-[#FF7A00] text-2xl leading-none"
                >
                    x
                </button>

                <h2 className="text-2xl font-bold mb-4">
                    Covered States
                </h2>

                <div className="flex flex-wrap gap-2">
                    {states && states.length > 0 ? (
                        states.map((state) => (
                            <span
                                key={state}
                                className="px-3 py-1 bg-[#F97316]/10 text-[#F97316] font-medium rounded-lg"
                            >
                                {state}
                            </span>
                        ))
                    ) : (
                        <p className="text-gray-500">No states listed.</p>
                    )}
                </div>
            </div>
        </div>
    );
}
